import { TOGGLE_ADMIN_VIEW } from '../actionTypes';

export const toggleAdminView = () => dispatch =>
  dispatch({ type: TOGGLE_ADMIN_VIEW });
